import React from 'react';

const Accessibility = () => {
  return (
    <div className="accessibility-page">
      <h1>Accessibility Statement</h1>
      {/* Accessibility Statement content will go here */}
    </div>
  );
};

export default Accessibility; 